(() => {
  if (window.__rbMobileStickyAtcLoaded) return;
  window.__rbMobileStickyAtcLoaded = true;
  const MAIN_BUTTON_SELECTOR = [
    '[data-rbq-root][data-purchase-mode="cart"] [data-rbq-submit]',
    '.rbbb__button.product-form__submit[name="add"]',
    'product-form .product-form__submit[name="add"]',
    '.product-form__submit[name="add"]',
  ].join(',');

  let frame = null;
  let stickyBar = document.querySelector('.rb-mobile-sticky-atc');
  let resetTimer = null;
  let observer = null;
  let observing = false;

  const findMainButton = () => {
    const buttons = Array.from(document.querySelectorAll(MAIN_BUTTON_SELECTOR));
    return (
      buttons.find((button) => button.matches('[data-rbq-submit]') && button.form && !button.closest('quick-add-modal')) ||
      buttons.find((button) => button.matches('.rbbb__button') && button.form) ||
      buttons.find((button) => button.form && !button.closest('quick-add-modal')) ||
      null
    );
  };

  const cartIsOpen = () =>
    Boolean(
      document.querySelector(
        '.ia-sliding-cart--active, cart-drawer.active, cart-drawer[open], .cart-drawer.active'
      )
    );

  const getProductData = (mainButton) => {
    const productRoot = mainButton?.closest('product-info, .product, main') || document;
    const title =
      productRoot.querySelector('.product__title h1, h1')?.textContent?.trim() ||
      '';
    const price =
      mainButton?.closest('[data-rbq-root]')?.querySelector('[data-rbq-total]')?.textContent?.trim() ||
      productRoot.querySelector('.rbbb__price-current, .price-item--sale, .price-item--regular')?.textContent?.trim() ||
      '';
    const image =
      productRoot.querySelector('.product__media img')?.currentSrc ||
      productRoot.querySelector('.product__media img')?.src ||
      '';

    return { title, price, image };
  };

  const setVisible = (visible) => {
    if (!stickyBar) return;
    stickyBar.classList.toggle('is-visible', visible);
    stickyBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
  };

  const syncBar = () => {
    frame = null;
    const mainButton = window.scrollY > 0 && findMainButton();
    const pastButton = mainButton && mainButton.getBoundingClientRect().bottom < 0;
    if (Boolean(pastButton) !== observing) {
      observing = Boolean(pastButton);
      if (observing) {
        observer.observe(document.documentElement, {
          childList: true, subtree: true, attributes: true,
          attributeFilter: ['class', 'open', 'disabled', 'aria-disabled', 'aria-busy', 'data-rbq-available'],
        });
      } else {
        observer.disconnect();
      }
    }
    if (!pastButton || !stickyBar) {
      setVisible(false);
      return;
    }

    const previewBar = document.querySelector('#PBarNextFrameWrapper');
    const previewBarHeight = previewBar ? Math.round(previewBar.getBoundingClientRect().height) : 0;
    stickyBar.style.setProperty('--rb-preview-bar-height', `${previewBarHeight}px`);

    const product = getProductData(mainButton);
    const image = stickyBar.querySelector('.rb-mobile-sticky-atc__image');
    const title = stickyBar.querySelector('.rb-mobile-sticky-atc__title');
    const price = stickyBar.querySelector('.rb-mobile-sticky-atc__price');
    const button = stickyBar.querySelector('.rb-mobile-sticky-atc__button');

    if (image && product.image && image.src !== product.image) image.src = product.image;
    if (product.title && title.textContent !== product.title) title.textContent = product.title;
    if (price.textContent !== product.price) price.textContent = product.price;

    const unavailable = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true' || mainButton.closest('[data-rbq-root]')?.dataset.rbqAvailable === 'false';
    const isAdding = mainButton.classList.contains('loading') || mainButton.getAttribute('aria-busy') === 'true';
    button.disabled = unavailable;
    const label = isAdding
      ? (window.RBUI?.adding || 'Adding…')
      : unavailable
        ? stickyBar.dataset.soldOutLabel || (window.RBUI?.sold_out || 'Sold out')
        : stickyBar.dataset.addLabel || (window.RBUI?.add_to_cart || 'Add to cart');
    if (button.textContent !== label) button.textContent = label;

    const shouldShow =
      !unavailable &&
      !cartIsOpen();

    setVisible(shouldShow);
  };

  const requestSync = () => {
    if (frame !== null) return;
    frame = window.requestAnimationFrame(syncBar);
  };

  const init = () => {
    if (!stickyBar) return;

    const stickyButton = stickyBar.querySelector('.rb-mobile-sticky-atc__button');
    stickyButton.addEventListener('click', () => {
      const mainButton = findMainButton();
      const unavailable =
        !mainButton ||
        !mainButton.form ||
        mainButton.disabled ||
        mainButton.getAttribute('aria-disabled') === 'true';
      if (unavailable) return;

      stickyButton.disabled = true;
      stickyButton.textContent = (window.RBUI?.adding || 'Adding…');

      // Delegate to the real product button. This preserves the selected
      // variant, quantity, Dawn analytics and the existing Oxify drawer flow.
      mainButton.click();
      const bundle = mainButton.closest('[data-rbq-root]');
      if (bundle?.querySelector('.is-error')) {
        bundle.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }

      window.clearTimeout(resetTimer);
      resetTimer = window.setTimeout(requestSync, 2200);
    });

    observer = new MutationObserver((records) => {
      if (records.some((record) => !stickyBar.contains(record.target))) requestSync();
    });
    window.addEventListener('pageshow', requestSync);
    window.addEventListener('scroll', requestSync, { passive: true });
    window.addEventListener('resize', requestSync, { passive: true });
    document.addEventListener('change', requestSync);
    document.addEventListener('shopify:section:load', requestSync);
    requestSync();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
